import { Theme } from "@mui/material";
import { height } from "@mui/system";

const useStyles = (theme: Theme) => ({
  fontsizeTicks: {
    fill: theme.palette.text.charts, // Cor do texto dos ticks
    fontSize: "0.8rem",
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    //fontWeight: 500,
  },
  boxContainer: {
    height: "100%",
    containerType: "size",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
  },
  boxContainerSizeChart: {
    overflow: "hidden",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "column",
    "&:hover": {
      overflow: "visible",
    },
  },
  boxChart: (boxHeight: number | null, boxWidth: number | null) => ({
    // width: boxWidth ? boxWidth - 12 : "100%", // não ative pois na largura o grafico não expande
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: boxHeight ? boxHeight : "98%",
  }),
  boxLabelRadial: {
    // height: boxHeight,
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
  },
  boxLegend: {
    width: "100%",
    height: "clamp(10px, 10cqh, 100px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
  },
  boxLegendRadial: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: 3,
  },
  boxPie: (boxHeight: number | null) => ({
    flex: 1,
    height: boxHeight,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    overflow: "hidden",
  }),
  dataGrid: {
    width: "100%",
    height: "100%",
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      // display: "none",
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.secondary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "45px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: "table" },
    "& .odd-row": { backgroundColor: "background.paper" },
  },
});

export default useStyles;
